/* eslint-disable */
<template>
  <div id="admin-table-container">
    <AdminTableToolbar></AdminTableToolbar>
    <AdminTable></AdminTable>
    <AdminTablePagination></AdminTablePagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AdminTableToolbar from './AdminTableToolbar';
import AdminTable from './AdminTable';
import AdminTablePagination from './AdminTablePagination';

export default {
  name: 'admin-table-container',
  components: {
    AdminTableToolbar,
    AdminTable,
    AdminTablePagination,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'activeView',
    ]),
    ...mapGetters('admin', [
      'activeViewAdmin',
    ]),
  },
};
</script>

<style scoped>
#admin-table-container {
  width: 100%;
  height: 100%;
}
</style>
